/* eslint-disable react/prop-types */
import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { PersonalDetailsView } from '../../details/personal-detail';
import { AddressDetailsView } from '../../details/address-details';
import { ContactDetailsView } from '../../details/contact-details';
import { EmploymentDetailsView } from '../../details/employment-details';
import { FormDetails } from '../../form-details-reducer';
import { Nullable } from '../../../../../../shared-types';
import { ClaimType } from '../../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}

interface Props extends StyledComponent, BaseProps {}

const policyHolderDetailsView: React.FunctionComponent<Props> = ({
    formDetails,
    disableEditButton,
    claimType,
}) => {
    const isThePolicyHolderAnIndividualOrCompany =
        formDetails?.policyHolder?.policyHolderType ||
        (formDetails?.policyHolder as any)?.IsThePolicyHolderAnIndividualOrCompany;
    return (
        <ExpansionPanel name="Policyholder details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <PersonalDetailsView
                    type="PolicyHolder"
                    formDetails={formDetails}
                    disableEditButton={false}
                />
                <AddressDetailsView
                    type="PolicyHolder"
                    formDetails={formDetails}
                    disableEditButton={false}
                />
                {isDreadOrTerminalIllness() && (
                    <ContactDetailsView
                        type="PolicyHolder"
                        formDetails={formDetails}
                        disableEditButton={false}
                    />
                )}
                {isDreadOrTerminalIllness() &&
                    isThePolicyHolderAnIndividualOrCompany !== 'Company' && (
                        <EmploymentDetailsView
                            formDetails={formDetails}
                            disableEditButton={false}
                            claimType={claimType}
                        />
                    )}
            </React.Fragment>
        </ExpansionPanel>
    );
    function isDreadOrTerminalIllness() {
        return claimType === ClaimType.Dread || claimType === ClaimType.TerminalIllness;
    }
};

export const PolicyHolderDetailsView = withStyles(styles)(policyHolderDetailsView);
